export default __webpack_public_path__ + "static/media/thumnail-4.9fcfaef5.jpg";